import { forwardRef } from "react";
import { ResponsiveBlockSwitcher } from "@/shared/Components";
import type { PropsWithChildren, ReactNode } from "react";
import { GridItemContainerDesktop } from "./desktop";
import { GridItemContainerMobile } from "./mobile";

type Props = {
  onRemoveClick?: () => void;
  title: string;
  headerAddableNode?: ReactNode;
};

export const GridItemContainer = forwardRef<HTMLDivElement, PropsWithChildren<Props>>(
  ({ children, title, onRemoveClick, headerAddableNode }, ref) => {
    return (
      <ResponsiveBlockSwitcher
        desktop={
          <GridItemContainerDesktop
            ref={ref}
            title={title}
            onRemoveClick={onRemoveClick}
            headerAddableNode={headerAddableNode}
          >
            {children}
          </GridItemContainerDesktop>
        }
        mobile={
          <GridItemContainerMobile ref={ref} title={title}>
            {children}
          </GridItemContainerMobile>
        }
      />
    );
  },
);
